import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { TextLoca } from "../../generic/text/TextLoca";
export var BuildingMaxed = function () {
    return (
    // TODO: Consider HOC
    React.createElement("div", { className: IdStyles.TextButtonHeading + " flex flex--guts flex__full" },
        React.createElement(TextLoca, { id: IdLoca.maxLimitReached })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/BuildingMaxed.tsx
// module id = 936
// module chunks = 3